import axios from 'axios';
import moment from 'moment';
//import { toast } from 'react-toastify';
import { variablesPath } from '../variables/Variables'

export const deleteBd = async (id, path) => {
    try {
        await fetch(variablesPath.API_URL + `${path}/${id}`, {
            method: 'DELETE',
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                //toast.warning(data);
            });
    } catch (e) {
        throw new Error(e)
    }
};

export const deleteBdNoId = async (path, noMostrar) => {
    try {
        console.log(variablesPath.API_URL + `${path}`);
        await fetch(variablesPath.API_URL + `${path}`, {
            method: 'DELETE',
        })
            .then(response => {
                return response.text();
            })
        /* .then(data => {
            if (!noMostrar) toast.warning(data);
        }); */
    } catch (e) {
        //throw new Error(e)
    }
};

export const getTableBd = async (path) => {
    try {
        const res = await axios.get(variablesPath.API_URL + path)
        return (res.data);
    } catch (e) {
        console.error(e);
        throw new Error(e)
    }
};

export const getTableByIdBd = async (id, path) => {
    try {
        const res = await axios.get(variablesPath.API_URL + path + '/' + id)
        return (res.data);
    } catch (e) {
        return ([])
    }
};

export const updateTableBd = async (path, dataSend) => {
    try {
        const response = await axios.put(variablesPath.API_URL + path, dataSend, {
            headers: { 'Content-Type': 'application/json', },
        });
        return response.data;
    } catch (e) {
        throw new Error(e)
    }
};

export const insertTableBd = async (path, dataSend) => {
    try {
        const response = await axios.post(variablesPath.API_URL + path, dataSend, {
            headers: { 'Content-Type': 'application/json', },
        });
        return response.data;
    } catch (e) {
        throw new Error(e)
    }
};

/* export const validarMobil = (setMobile, setHorizontal) => {
    const handleResize = () => {
        if (window.innerWidth < 768 || window.innerHeight < 500) {
            setMobile(true)
            setHorizontal(window.innerWidth > window.innerHeight);
        }
        else {
            setMobile(false)
            setHorizontal(false);
        }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize) };
} */

// Variable global para el debounce (fuera de la función para persistir entre llamadas)
let globalResizeTimeout;

export const validarMobil = (setMobile, setHorizontal, tipoDispositivo) => {
    
    const detectAndSet = () => {
        // Detectar dispositivo móvil usando múltiples métodos (no solo ancho)
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        // Si tiene userAgent móvil Y tiene capacidad táctil, ES móvil (sin importar el tamaño de pantalla)
        const isMobile = isMobileUserAgent && isTouchDevice;

        // Determinar orientación - usar comparación de dimensiones (más confiable)
        const isHorizontal = window.innerWidth > window.innerHeight;

        /* console.log('📱 validarMobil [ANTES de setState]:', { 
            timestamp: new Date().toISOString(),
            isMobile,
            sentToSetMobile: isMobile,
            isHorizontal: isMobile && isHorizontal,
            sentToSetHorizontal: isMobile && isHorizontal,
            rawIsHorizontal: isHorizontal,
            width: window.innerWidth,
            height: window.innerHeight,
            userAgent: isMobileUserAgent,
            touch: isTouchDevice,
            maxTouchPoints: navigator.maxTouchPoints,
            hasOntouchstart: 'ontouchstart' in window
        }); */
        
        setHorizontal(isMobile && isHorizontal);
        setMobile(isMobile);
    };
    
    const handleResize = () => {
        // Limpiar timeout anterior si existe
        if (globalResizeTimeout) {
            clearTimeout(globalResizeTimeout);
        }
        
        // Esperar a que la rotación se complete antes de detectar
        globalResizeTimeout = setTimeout(detectAndSet, 150);
    };

    // Primera detección inmediata (solo al montar)
    detectAndSet();

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
    };
};



//---------------------------------------------------------------------

export const getVariables = async (setVariables) => {
    const vars = await getTableBd('getvars')
    setVariables(vars);
}

//--------------------------------------------------------------------

export const ordenar = (columna) => {
    var tables, rows, sorting, c, a, b, tblsort;
    tables = document.getElementById("myTable");
    sorting = true;
    while (sorting) {
        sorting = false;
        rows = tables.rows;
        for (c = 1; c < (rows.length - 1); c++) {
            tblsort = false;
            a = rows[c].getElementsByTagName("TD")[columna];
            b = rows[c + 1].getElementsByTagName("TD")[columna];
            if (a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase()) {
                tblsort = true;
                break;
            }
        }
        if (tblsort) {
            rows[c].parentNode.insertBefore(rows[c + 1], rows[c]);
            sorting = true;
        }
    }
};

export const ordenarArreglo = (columna, arreglo, setArreglo, direccion = 'asc') => {
    if (!Array.isArray(arreglo) || arreglo.length === 0) return;

    const clon = [...arreglo];
    clon.sort((a, b) => {
        let valA = a?.[columna];
        let valB = b?.[columna];

        // Normalizar strings vacíos o solo espacios a null
        if (typeof valA === 'string' && valA.trim() === '') valA = null;
        if (typeof valB === 'string' && valB.trim() === '') valB = null;

        const aEsNulo = valA === undefined || valA === null;
        const bEsNulo = valB === undefined || valB === null;

        if (aEsNulo && bEsNulo) return 0;
        // Los valores nulos o vacíos se ubican siempre al final (tanto en asc como en desc)
        if (aEsNulo) return 1;
        if (bEsNulo) return -1;

        let res = 0;
        // Comprobar si ambos son numéricos válidos
        const esNumA = typeof valA === 'number' || (typeof valA === 'string' && valA.trim() !== '' && !isNaN(Number(valA)));
        const esNumB = typeof valB === 'number' || (typeof valB === 'string' && valB.trim() !== '' && !isNaN(Number(valB)));

        if (esNumA && esNumB) {
            res = Number(valA) - Number(valB);
        } else {
            const strA = String(valA).trim();
            const strB = String(valB).trim();
            res = strA.localeCompare(strB, 'es', { numeric: true, sensitivity: 'base' });
        }

        return direccion === 'desc' ? -res : res;
    });

    setArreglo(clon);
    return clon;
};

export const compararFechas = (f1, f2, tipo) => {
    const f1Date = new Date(f1);
    const f2Date = new Date(f2);
    if (tipo === 'inicial') {
        if (f1Date < f2Date) return f1
        return f2
    }
    if (tipo === 'final') {
        if (f1Date < f2Date) return f2
        return f1
    }
}


export const txVivo = (fecha) => {
    const lastTransmission = moment(fecha);
    const now = moment();
    const differenceInMinutes = now.diff(lastTransmission, 'minutes');
    let tx = false;
    if (differenceInMinutes <= 5) {
        tx = true
    } else {
        tx = false
    }
    return tx
}

export const formatFecha = (fecha) => {
    const fechaFormateada = moment(fecha).format('YYYY-MM-DD HH:mm:ss');
    return fechaFormateada
}